import {
  Paragraph,
  TextRun,
  Tab,
  TabStopType,
} from "docx"
import { renderEducationSection } from "./renderEducationSection"
import { renderLeadershipSection } from "./renderLeadershipSection"
import { renderWorkSection } from "./renderWorkSection"
import { renderVolunteerSection } from "./renderVolunteerSection"
import { renderLifeSection } from "./renderLifeSection"
import { renderSkillsInterestsSection } from "./renderSkillsInterestsSection"
import { renderAwardsSection } from "./renderAwardSection"
import { renderCertificateSection } from "./renderCertificateSection"
import { renderCourseworkSection } from "./renderCourseworkSection"

const accentTemplate = (
  name,
  city,
  state,
  email,
  work,
  education,
  volunteer,
  awards,
  life,
  leadership,
  certificate,
  coursework,
  skills,
  interests,
  sectionOrder,
  introduction,
) => {
  const typeToSection = {
    "education": renderEducationSection(education),
    "work": renderWorkSection(work),
    "leadership": renderLeadershipSection(leadership),
    "volunteer": renderVolunteerSection(volunteer),
    "award": renderAwardsSection(awards),
    "life": renderLifeSection(life),
    "skills": renderSkillsInterestsSection("skills", skills),
    "certificate": renderCertificateSection(certificate),
    "coursework": renderCourseworkSection(coursework),
    "interests": renderSkillsInterestsSection("interests", interests),
  }

  return {
    styles: {
      default: {
        document: {
          run: {
            font: "Calibri",
          },
        },
      },
    },
    sections: [
      {
        properties: {
          page: {
            margin: {
              top: 720,
              right: 720,
              bottom: 300,
              left: 720,
            },
          },
        },
        children: [
          ...createResumeHeader(name, city, state, email),
          ...(sectionOrder.map(type => typeToSection[type] || []).flat()),
        ],
      },
    ],
  }
}

/**
 * Generates the header section for the accent template
 */
const createResumeHeader = (name, city, state, email) => {
  const headerTabStops = [
    {
      position: 5225,
      type: TabStopType.LEFT,
    },
    {
      position: 7837.5,
      type: TabStopType.LEFT,
    },
  ]

  return [
    new Paragraph({
      tabStops: headerTabStops,
      children: [
        new TextRun({
          text: name,
          bold: true,
          size: 32,
        }),
        new TextRun({ 
          children: [
            new Tab(),
            "Phone",
            new Tab(),
            "Email",
          ],
          bold: true,
        }),
      ],
    }),
    new Paragraph({
      tabStops: headerTabStops,
      children: [
        new TextRun({ 
          children: [
            new Tab(),
            "PHONE",
            new Tab(),
            email,
          ],
        }),
      ],
    }),
    new Paragraph({
      tabStops: headerTabStops,
      children: [
        new TextRun({ 
          children: [
            new Tab(),
            "Location",
            new Tab(),
            "LinkedIn",
          ],
          bold: true,
        }),
      ],
    }),
    new Paragraph({
      tabStops: headerTabStops,
      children: [
        new TextRun({ 
          children: [
            new Tab(),
            `${city}, ${state}`,
            new Tab(),
            "LINKEDIN",
          ],
        }),
      ],
    }),
  ]
}

export default accentTemplate
